module.exports = __webpack_public_path__ + "static/media/shell.fed37460.svg";